import { IonIcon } from '@ionic/react'
import dayjs from 'dayjs'
import { trophy } from 'ionicons/icons'
import React, { FC, useContext } from 'react'
import { useTranslation } from 'react-i18next'
import { ModalContext, ModalVariableTypes } from '../../contexts/ModalContext'
import i18n from '../../i18n'
import ModalWrapper from '../../wrappers/modalWrapper/ModalWrapper'
import BadgeComponent from './components/BadgeComponent'

const TierDetails: FC = () => {
	const { t } = useTranslation('modals_badges')

	const { currentModal } = useContext(ModalContext)
	const tierData = currentModal?.modalVariable as ModalVariableTypes['badges-detail']

	const tierName = i18n.language === 'en' ? tierData.tier.tierNameEn : tierData.tier.tierNameFi
	const tierDescription =
		i18n.language === 'en' ? tierData.tier.tierDescriptionEn : tierData.tier.tierDescriptionFi
	const earnedCount = tierData.userBadge?.earnedCount || 0

	return (
		<ModalWrapper appBarOptions={{ label: tierName }}>
			<div className='p-6 flex flex-col items-center gap-12'>
				<div className='flex flex-col items-center gap-4'>
					<span className='text-2xl font-bold text-text-dark dark:text-white'>{tierName}</span>

					<span className='text-text-grey-200 dark:text-text-grey-100 text-sm'>
						{tierDescription}
					</span>
				</div>

				<div className='w-3/4'>
					<BadgeComponent
						badge={tierData.badge}
						tier={tierData.tier}
						isCompleted={tierData.isCompleted}
					/>
				</div>

				{tierData.userBadge && (
					<div className='flex flex-col items-center gap-2'>
						<div className='flex flex-row justify-center items-center gap-2 font-medium text-text-dark dark:text-white'>
							<IonIcon icon={trophy} />

							{earnedCount === 1
								? t('timesEarnedSingular')
								: t('timesEarned', '', { count: earnedCount })}
						</div>

						{tierData.userBadge.lastEarnedAt && (
							<span className='font-medium text-text-dark dark:text-white'>
								{t('lastEarned', {
									lastEarned: dayjs(tierData.userBadge.lastEarnedAt).format('DD.MM.YYYY'),
								})}
							</span>
						)}
					</div>
				)}
			</div>
		</ModalWrapper>
	)
}

export default TierDetails
